import moment from 'moment';
import React from 'react';
import CryptoJS from 'crypto-js';

/**
 * Groups the customers by the first name Character
 * @param data - Customers Array
 * @param field - the filed to group by
 */
export const groupAndSortItemsByField = (data, field) => {
    const sortedCustomerData = {};
    data.forEach(item => {
        if (!item[field]) {
            return {'-': data};
        }
        if (sortedCustomerData[item[field].charAt(0).toUpperCase()]) {
            sortedCustomerData[item[field].charAt(0).toUpperCase()].push(item);
        } else {
            sortedCustomerData[item[field].charAt(0).toUpperCase()] = [item];
        }
    });

    const orderedCustomerData = {};
    Object.keys(sortedCustomerData).sort().forEach(key => {
        orderedCustomerData[key] = sortedCustomerData[key];
    });
    return orderedCustomerData;
};

/**
 * filter an array of object by specifying the field and the query.
 * @param items - array of objects
 * @param fields - object fields to filter on
 * @param filter - filter query
 * @returns {*}
 */
export const filterObjectsBy = (items = [], fields = [], filter = '') => items.filter(item => {
    for (let i = 0; i < fields.length; i++) {
        let field = item[fields[i]];
        if (!field) return false;
        field = `${field}`;
        if (typeof field !== 'string') return false;

        if (field.toLowerCase().includes(filter.toLowerCase())) return true;
    }

    return false;
});

export const padString = (string, prefix, minLength) => {
    string = string.toString().padStart(minLength, '0');
    return prefix + string;
};

export const getDurationInMonth = (startDate, endDate) => ((startDate && endDate) ?
    `${Math.ceil(moment(endDate).diff(moment(startDate), 'months', true))} Months` : 'Unavailable');

export const fillArray = (value, len) => {
    const arr = [];
    for (let i = 0; i < len; i++) {
        arr.push(value);
    }
    return arr;
};

export const getCreationTime = date => {
    const timeCreated = moment(date);
    return timeCreated.fromNow(false);
};

export const capitalizeFirst = str => str.charAt(0).toUpperCase() + str.slice(1);

export const encryptData = data => new Promise(resolve => {
    const encryptedData = CryptoJS.AES.encrypt(data, process.env.REACT_APP_ENCRYPTION_SECRET).toString();
    return resolve(encryptedData);
});

export const decryptData = encryptedText => new Promise(resolve => {
    // todo: may need to re-evaluate, could be unsafe
    const formattedEncryptedText = encryptedText.replace(/ /g, '+');

    const bytes = CryptoJS.AES.decrypt(formattedEncryptedText, process.env.REACT_APP_ENCRYPTION_SECRET);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

    return resolve(decryptedData);
});
